import { makeAutoObservable } from 'mobx'
import { animateItem } from 'page/catalog/store/elements/animateItem'

export class ElementsStore {
  private readonly items = new Map<string, HTMLElement>()

  constructor() {
    makeAutoObservable(this)
  }

  onItem(item_id: string, image: HTMLElement | null | undefined) {
    if (image) this.items.set(item_id, image)
    else this.items.delete(item_id)
  }

  animateItem(item_id: string) {
    const image = this.items.get(item_id)
    if (image) animateItem(image)
  }
}

export const elements = new ElementsStore()
